import type { PendingForm } from '@/api/types/Forms'
import { Dot, Row, RowGroup } from '@/components/Rows'
import { Sheet, SheetTitle } from '@/ui/core/sheet'
import { openForm } from './TodoFormRow'

/**
 * The to-do list, as a sheet: the title with its glyph, then the same row every other list in
 * the app uses, its disc numbered the way the membership sheet numbers what's included, then the
 * name and the coral dot that says this one wants you. Each
 * row pushes its own page; the sheet closes first, since a route pushed under an open modal
 * navigates behind it. When the member comes back the row is gone, and when the last one goes
 * the tile goes with it. Nothing else lives here.
 */
export const TodoSheet = ({
	open,
	onClose,
	forms,
}: { open: boolean; onClose: () => void; forms: PendingForm[] }) => (
	<Sheet open={open} onClose={onClose}>
		<SheetTitle glyph="asterisk" turning>
			To Do
		</SheetTitle>
		{/* The group's blush card gives the marks their ground and the rows the title's inset;
		    it needs no title of its own, since the sheet's says To Do. */}
		<RowGroup>
			{forms.map((form, index) => (
				<Row
					key={form.id}
					status="due"
					title={form.name}
					mark={String(index + 1).padStart(2, '0')}
					tag={<Dot />}
					onPress={() => {
						onClose()
						openForm(form)
					}}
					last={index === forms.length - 1}
				/>
			))}
		</RowGroup>
	</Sheet>
)
